// Custom alpine directives go here
//
// For example, `x-uppercase`:
//
// Alpine.directive('uppercase', (el) => {
//   el.textContent = el.textContent.toUpperCase();
// });

const { mutateDom, initTree } = Alpine;
// const PILLBOX_ID = 47826481578276;
const ANTISPIKE_US_ID = 47498715824420;
const RECIPE_CLUB_ID = 47461872173348;

// Flag pour détecter les requêtes de synchronisation automatique (page précédente/suivante)
let _isAutoSyncRequest = false;

const getCartSections = async () => {
  const sections = await fetch(Shopify.routes.root + '?sections=cart-items,cart-footer,cart-item-count')
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("error: ", error);
    });

  return sections;
}

const updateCartDOM = async (cartData, options = {}) => {
  const { openCart = true } = options;

  try {
    const sections = await getCartSections();
    if (!sections) return;

    cartData.sections = sections;

    // Mise à jour asynchrone des composants pour permettre un rendu plus rapide
    const updatePromises = [];

    const cartFooterEl = document.querySelector('[x-data="ThemeModule_CartFooter"]');
    if (cartFooterEl) {
      const cartFooterComponent = Alpine.$data(cartFooterEl);
      updatePromises.push(
        cartFooterComponent._morphFooter({
          detail: { response: cartData }
        })
      );
    }

    const cartItemsEl = document.querySelector('[x-data="ThemeModule_CartItems"]');
    if (cartItemsEl) {
      const cartItemsComponent = Alpine.$data(cartItemsEl);
      updatePromises.push(
        cartItemsComponent._morphItems({
          detail: { response: cartData }
        })
      );
    }

    // Exécuter toutes les mises à jour en parallèle plutôt qu'en séquence
    await Promise.all(updatePromises);

    // Ouvrir le panier seulement si demandé (pas pour les requêtes de sync automatique)
    if (openCart) {
      Alpine.store('modals').open('cart');
    }

    // Trigger cart quantity change event
  document.body.dispatchEvent(
      new CustomEvent('shapes:modalcart:cartqtychange', {
        bubbles: true,
        detail: { response: cartData }
      })
    );
        if (cartFooterEl) {
      const upsellWidget = [...document.querySelectorAll('#upsellplus_drawer_offer_v2')]
        .find((el) => !cartFooterEl.contains(el));
      if (upsellWidget) {
        const placeholder = cartFooterEl.querySelector('#upsellplus_drawer_offer_v2');
        if (placeholder) {
          placeholder.replaceWith(upsellWidget);
        } else {
          // Upsell is displayed above the cart summary (shipping, pillbox, subtotal)
          const summary = cartFooterEl.querySelector('[data-cart-summary]');
          if (summary) {
            summary.insertAdjacentElement('beforebegin', upsellWidget);
          }
        }
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartData }
      })
    );
  } catch (error) {
    console.error("error: ", error);
  }
}

// OK
function noMoreThan1RecipeClubInCart() {
  const items = window.liquidAjaxCart.cart.items;

  const recipeClubsInCart = items.filter(item => item.variant_id === RECIPE_CLUB_ID);

  // if there is no product, or it is only one -- do nothing, stop the function
  if (recipeClubsInCart.length === 0 || (recipeClubsInCart.length === 1 && recipeClubsInCart[0].quantity === 1)) return;

  const updates = {};

  // set the quantity of the first found line-item to 1,
  // set the quantity of the rest line-items to 0
  for (let i = 0; i < recipeClubsInCart.length; i++) {
    updates[recipeClubsInCart[i].key] = (i === 0 ? 1 : 0);
  }

  // initiate the update request
  return {
    requests: [
      {
        type: "update",
        body: {
          updates
        }
      }
    ]
  }
}

// To check
function validateAntispikesQuantityForCanada() {
  const cart = window.liquidAjaxCart.cart;
  const antispikesInCart = cart.items.filter(item => item.variant_id == ANTISPIKE_US_ID);
  const userCountry = localStorage.getItem('ELKAD-userShippingCountry') ? localStorage.getItem('ELKAD-userShippingCountry') : Shopify.country;

  // Si pas au Canada ou pas d'antispikes, on ne fait rien
  if ((userCountry !== 'CA' && userCountry !== 'AU') || antispikesInCart.length === 0) return null;

  const totalAntispikes = antispikesInCart.reduce((sum, item) => sum + item.quantity, 0);

  // Si la quantité est déjà correcte, on ne fait rien
  if (totalAntispikes <= 3) return null;

  // On met à jour toutes les quantités en une seule requête
  const updates = {};
  let remainingQuantity = 3;

  // On ajuste les quantités des antispikes
  antispikesInCart.forEach(item => {
    if (remainingQuantity > 0) {
      const newQuantity = Math.min(remainingQuantity, item.quantity);
      updates[item.key] = newQuantity;
      remainingQuantity -= newQuantity;
    } else {
      updates[item.key] = 0;
    }
  });

  return updates;
}

// To check
// function adjustPillboxQuantities() {
//   const cart = window.liquidAjaxCart.cart;

//   // On vérifie d'abord les antispikes pour le Canada et l'Australie
//   const antispikesUpdates = validateAntispikesQuantityForCanada();

//   const itemsWithAutoAddPillbox = cart.items.filter(item =>
//     //item.selling_plan_allocation && item.properties?._auto_add_pillbox
//     //The widget Videowise send a custom add request with no custom properties "_auto_add_pillbox".
//     //Use a json map (from theme.liquid) to recover this property.
//     item.selling_plan_allocation && (
//       item.properties?._auto_add_pillbox || window._auto_add_pillbox?.[item.product_id] === true
//     )
//   );
//   const pillboxInCart = cart.items.filter(item => item.id == PILLBOX_ID);

//   // Calcul de la quantité nécessaire en tenant compte des antispikes ajustés
//   const quantityNeeded = itemsWithAutoAddPillbox.reduce((acc, item) => {
//     if (antispikesUpdates && item.variant_id === ANTISPIKE_US_ID) {
//       // Si l'item est un antispike qui va être ajusté, on utilise la nouvelle quantité
//       return acc + (antispikesUpdates[item.key] || 0);
//     }
//     return acc + item.quantity;
//   }, 0);

//   const currentQuantity = pillboxInCart.reduce((acc, item) => acc + item.quantity, 0);

//   // Si aucun changement nécessaire et pas d'ajustement d'antispikes, on arrête
//   if (quantityNeeded === currentQuantity && !antispikesUpdates) return;

//   // Préparation des updates
//   const updates = { ...(antispikesUpdates || {}) };

//   // Si aucun pillbox n'est nécessaire, on ne fait rien
//   if (quantityNeeded === 0 && pillboxInCart.length > 0) {
//     pillboxInCart.forEach(item => {
//       updates[`${item.key}`] = 0;
//     });
//     return {
//       requests: [{
//         type: "update",
//         body: { updates }
//       }]
//     };
//   }

//   // Si aucun pillbox n'est dans le panier
//   if (pillboxInCart.length === 0) {
//     return {
//       requests: [
//         ...(Object.keys(updates).length > 0 ? [{
//           type: "update",
//           body: { updates }
//         }] : []),
//         {
//           type: "add",
//           body: {
//             id: `${PILLBOX_ID}`,
//             quantity: quantityNeeded
//           }
//         }
//       ]
//     };
//   }

//   // Si plusieurs pillbox, on garde le premier et on supprime les autres
//   if (pillboxInCart.length > 1) {
//     // Mettre à 0 tous les pillbox sauf le premier
//     pillboxInCart.slice(1).forEach(item => {
//       updates[`${item.key}`] = 0;
//     });
//   }

//   // Mettre à jour la quantité du premier pillbox
//   updates[pillboxInCart[0].key] = quantityNeeded;

//   return {
//     requests: [{
//       type: "update",
//       body: { updates }
//     }]
//   };
// }

// OK
function validateProductVariantsByMarket() {
  const cart = window.liquidAjaxCart.cart;
  const cartItems = document.querySelectorAll('.js-elkad-cart-item');

  if (!cartItems.length) return;

  const userShippingCountry = document.querySelector("#user-shipping-country");
  const country = userShippingCountry ? userShippingCountry.value : Shopify.country;

  let productsWithWrongVariant = [];
  let newVariants = {};

  // Analyse des variants à changer
  for (let item of cartItems) {
    try {
      let variantsStrings = item.getAttribute("data-localized-variant").replace(",}", "}");
      let variants = JSON.parse(variantsStrings);

      if (!variants[country]) continue;

      const variantId = variants[country];
      if (variantId == undefined) continue;

      const productId = item.getAttribute("data-product-id");
      const wrongVariants = cart.items.filter(item =>
        item.product_id == productId &&
        item.id != variantId
      );

      if (wrongVariants.length > 0) {
        productsWithWrongVariant.push(...wrongVariants);
        newVariants[productId] = variantId;
      }
    } catch (e) {
      console.error("Error parsing variants for item:", e);
    }
  }

  // Si aucun changement nécessaire, on arrête
  if (productsWithWrongVariant.length === 0) return;

  // Préparation des requêtes
  const updates = {};
  const itemsToAdd = [];

  for (const item of productsWithWrongVariant) {
    // Marquer l'item à supprimer
    updates[item.key] = 0;

    const newVariantId = newVariants[item.product_id];
    // Vérifier si la nouvelle variante n'est pas déjà dans le panier
    const variantAlreadyInCart = cart.items.some(cartItem =>
      cartItem.id == newVariantId
    );

    if (!variantAlreadyInCart) {
      itemsToAdd.push({
        id: newVariantId,
        quantity: item.quantity,
        selling_plan: item.selling_plan_allocation?.selling_plan.id || null,
        properties: item.properties
      });
    }
  }

  // Création des requêtes
  const requests = [];

  // Requête pour supprimer les anciennes variantes
  if (Object.keys(updates).length > 0) {
    requests.push({
      type: "update",
      body: { updates }
    });
  }

  // Requête pour ajouter les nouvelles variantes
  if (itemsToAdd.length > 0) {
    requests.push({
      type: "add",
      body: { items: itemsToAdd }
    });
  }

  return { requests };
}

// Mise à jour de la configuration des mutations
window.liquidAjaxCart.conf("mutations", [
  noMoreThan1RecipeClubInCart,
  validateProductVariantsByMarket
  // adjustPillboxQuantities
]);

document.addEventListener("liquid-ajax-cart:queue-start", e => {
  // console.log("========================= QUEUE START =========================");
  cartAddLoadingState();
});

document.addEventListener("liquid-ajax-cart:request-start", async e => {
  const { requestState } = e.detail;

  // Détecter les requêtes de synchronisation automatique (page précédente/suivante)
  // Ces requêtes sont de type "update" avec un body vide et sans info personnalisée
  const isEmptyUpdate = requestState.requestType === "update" &&
    (!requestState.requestBody?.updates || Object.keys(requestState.requestBody.updates).length === 0);
  const hasNoCustomInfo = !requestState.info?.source;

  _isAutoSyncRequest = isEmptyUpdate && hasNoCustomInfo;
});

document.addEventListener("liquid-ajax-cart:request-end", async e => {
  // console.log("REQUEST END")
  const { requestState } = e.detail;

  if (requestState.requestType == "add") {
    const matchingCartItem = window.liquidAjaxCart.cart.items.find(cartItem => cartItem.key == requestState.responseData.body.key);

    if (matchingCartItem) {
      matchingCartItem.quantity += requestState.responseData.body.quantity;
    } else {
      const itemsToPush = requestState.responseData.body.items ? requestState.responseData.body.items : [requestState.responseData.body];
      window.liquidAjaxCart.cart.items.push(...itemsToPush);
    }
  }
});

document.addEventListener("liquid-ajax-cart:queue-end", async e => {
  // console.log("========================= QUEUE END =========================");
  const cartData = window.liquidAjaxCart.cart;

  // Ne pas ouvrir le panier si c'est une requête de sync automatique (page précédente/suivante)
  await updateCartDOM(cartData, { openCart: !_isAutoSyncRequest });

  // Réinitialiser le flag
  _isAutoSyncRequest = false;

  cartRemoveLoadingState();
});

const cartAddLoadingState = () => {
  const cartDrawerContentOverlay = document.querySelector('#cart-drawer-content-overlay');
  const cartDrawerFooterOverlay = document.querySelector('#cart-drawer-footer-overlay');

  if (cartDrawerContentOverlay) {
    cartDrawerContentOverlay.classList.remove('hidden');
  }

  if (cartDrawerFooterOverlay) {
    cartDrawerFooterOverlay.classList.remove('hidden');
  }
}

const cartRemoveLoadingState = () => {
  const cartDrawerContentOverlay = document.querySelector('#cart-drawer-content-overlay');
  const cartDrawerFooterOverlay = document.querySelector('#cart-drawer-footer-overlay');

  if (cartDrawerContentOverlay) {
    cartDrawerContentOverlay.classList.add('hidden');
  }

  if (cartDrawerFooterOverlay) {
    cartDrawerFooterOverlay.classList.add('hidden');
  }

  const allLoadingButton = document.querySelectorAll('.elkad-js-button--loading');

  allLoadingButton.forEach(button => {
    button.classList.remove('elkad-js-button--loading');
  })
}

Alpine.magic('fetchedSection', () => {
  return (url, selector) => {
    return async () => {
      return await fetchSectionHTML(url, selector);
    };
  };
});

Alpine.directive(
  'html-if-set',
  (el, { expression }, { effect, evaluateLater }) => {
    let evaluate = evaluateLater(expression);

    function saveInitialHTML() {
      el._x_custom_initialHTML = el.innerHTML;
    }

    function getInitialHTML() {
      return el._x_custom_initialHTML;
    }

    effect(() => {
      let newHTML;

      evaluate((value) => {
        if (Boolean(value)) {
          newHTML = value;

          if (!getInitialHTML()) {
            saveInitialHTML();
          }
        } else {
          if (getInitialHTML()) {
            newHTML = getInitialHTML();
          }
        }

        if (newHTML) {
          mutateDom(() => {
            el.innerHTML = newHTML;

            el._x_ignoreSelf = true;
            initTree(el);
            delete el._x_ignoreSelf;
          });
        }
      });
    });
  }
);

document.addEventListener('DOMContentLoaded', () => {
  Alpine.start();
});
